const key = 'tracked_page';

export const trackPage = (path = null) => {
    window.lastPage = sessionStorage.getItem(key);
    sessionStorage.setItem(key, path ?? window.location.pathname);
};

